import { render, staticRenderFns } from "./DialogTaoPhieuCoGam.vue?vue&type=template&id=69f5f1bc"
import script from "./DialogTaoPhieuCoGam.vue?vue&type=script&lang=js"
export * from "./DialogTaoPhieuCoGam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports